import { type WorkspaceMembersPaginatedOptions } from './useWorkspaceMembersPaginated';

export const useKeyFunction =
  (
    queryStringOrOptions: string | WorkspaceMembersPaginatedOptions | undefined,
    pageSize: number,
  ) =>
  (page: number) => {
    if (typeof queryStringOrOptions === 'string' || !queryStringOrOptions) {
      return `/workspaces/members${queryStringOrOptions}&offset=${encodeURIComponent(
        page * pageSize,
      )}&limit=${encodeURIComponent(pageSize)}`;
    }

    const params = new URLSearchParams();
    if (queryStringOrOptions.filter) {
      params.append('filter', queryStringOrOptions.filter);
    }
    if (queryStringOrOptions.order) {
      params.append('order', queryStringOrOptions.order);
    }
    if (queryStringOrOptions.orderBy) {
      params.append('order_by', queryStringOrOptions.orderBy);
    }
    return `/workspaces/members?${params}`;
  };
